import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { UserListVM } from '../setup-training-types.model';
import { TrainingService } from '../training.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-send-training-popup',
  templateUrl: './send-training-popup.component.html',
  styleUrls: ['./send-training-popup.component.scss']
})
export class SendTrainingPopupComponent implements OnInit {
  UserList: UserListVM[];
  TrainingId:number;
  UserId:number[];
  sendEmail:boolean=false;
  warning:boolean=false;
  userId:number;
  route:boolean=false;
  constructor(
    public _dialogRef: MatDialogRef<SendTrainingPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _notify: NotificationsService,
    private _trainingService: TrainingService,
    private ref: ChangeDetectorRef,private _router: Router,
  ) { }

  ngOnInit() {
    this.LoadUserList();
    this.TrainingId = this.data.TrainingId;
    this.sendEmail=this.data.sendEmail;
    this.warning=this.data.warning;
    this.userId=this.data.userId;
    this.route=this.data.Route;
  }

  LoadUserList() {
    this._trainingService.LoadAccesibleUserList().subscribe(res => {
      this.UserList = res;
    })
  }

  SelectUser(){
    console.log("userselect", this.UserId)
  }

  onSendEmail(){
    this._trainingService.SendTrainingEmail(this.TrainingId, this.UserId).subscribe(res=>{
      if (res == true) {
        this._notify.success('Saved', 'Successfully Send Training Links');
        this._dialogRef.close(true)
      } else {
        this._notify.error('Failed', 'Failed to Send training Links');
      }
    })
  }

  onNoClick() {
    this._dialogRef.close(false);
  }

  OpenTraining(){
    if(this.route){
      this._router.navigate(['start-training', this.userId,this.TrainingId]);
      this._dialogRef.close(false);
    } 
    else 
      this._dialogRef.close(true);
  }
}
